module.exports = __webpack_public_path__ + "img/vscode.b96ed97.png";